import { DefaultItemType } from 'bold-ui'
import { CustomSingleSelectFieldProps, SelectField } from 'components/form'

export const items: DefaultItemType[] = [
  { value: 0.5 * 60, label: '30 minutos' },
  { value: 60, label: '1 hora (padrão)' },
  { value: 2 * 60, label: '2 horas' },
  { value: 4 * 60, label: '4 horas' },
  { value: 8 * 60, label: '8 horas' },
  { value: 168 * 60, label: 'Uma semana' },
  { value: 720 * 60, label: 'Um mês' },
]

export type IntervaloCadsusSelectModel = DefaultItemType

type IntervaloCadsusSelectFieldProps = CustomSingleSelectFieldProps<IntervaloCadsusSelectModel>

export function IntervaloCadsusSelectField(props: Readonly<IntervaloCadsusSelectFieldProps>) {
  return (
    <SelectField
      label='Desabilitar durante'
      items={items}
      itemToString={itemToString}
      clearable={false}
      defaultValue={items[1] as any}
      {...props}
    />
  )
}

const itemToString = (item: DefaultItemType | null) => item?.label
